<template>
  <div class="view-wrapper view-wrapper-with-header">
    <van-nav-bar title="订单详情" left-arrow @click-left="$router.go(-1)" class="fixed-top" />
    <div class="address" v-if="hasAddress">
      <div class="icon">
        <van-icon name="location-o" />
      </div>
      <div class="info">
        <div class="name" v-if="data.SelfPickup">
          <van-tag round type="danger">自提</van-tag>
        </div>
        <div class="name" v-else>{{data.Recipient}} {{data.RecipientMobile}}</div>
        <div class="detail" v-if="data.SelfPickup">北京东城区北池子大街67号大眼睛票务
          <p>时间：工作日 10:00 - 16:00</p>
        </div>
        <div class="detail" v-else>{{data.AddressDetail}}</div>
      </div>
    </div>
    <div class="section-group">
      <div class="header">
        <div class="left">商品列表</div>
        <div class="right red">{{getStatusText(data.OrderStatus)}}</div>
      </div>
      <div class="section-bg section-padding goods-list">
        <SkuItem v-for="item in data.Products" :goods="item" :key="item.Id"></SkuItem>
      </div>
    </div>
    <div class="section-group">
      <div class="section-bg section-padding">
        <div class="item-list">
          <div class="row">
            <div class="left">商品总额</div>
            <div class="right">￥{{data.ProductAmount}}</div>
          </div>
          <div class="row">
            <div class="left">运费</div>
            <div class="right">+￥{{data.ExpressFee}}</div>
          </div>
        </div>
      </div>
      <div class="footer">
        <div class="left"></div>
        <div class="right">
          实付金额：
          <span class="total-price">
            <span class="default-symbol">￥</span>
            {{data.TotalAmount}}
          </span>
        </div>
      </div>
    </div>
    <div class="section-group">
      <div class="section-bg section-padding">
        <div class="item-list">
          <div class="row">
            <div class="left">订单号</div>
            <div class="right">{{data.OrderNo}}</div>
          </div>
          <div class="row">
            <div class="left">下单日期</div>
            <div class="right">{{data.CreateTime}}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="section-group" v-if="data.Recharges && data.Recharges.length > 0">
      <div class="section-bg section-padding">
        <div class="item-list" v-for="(item, index) in data.Recharges" :key="'r'+index">
          <div class="row">
            <div class="left">充值账号</div>
            <div class="right">{{item.AccountId}}</div>
          </div>
          <div class="row">
            <div class="left">充值状态</div>
            <div class="right">{{ getRechargeStatusText(item.Status) }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="section-group" v-if="data.ExpressNo">
      <div class="section-bg section-padding">
        <div class="item-list">
          <div class="row">
            <div class="left">运单号</div>
            <div class="right">
              {{data.ExpressNo}}
              <van-tag plain round @click="doCopy('运单号',data.ExpressNo)">复制</van-tag>
            </div>
          </div>
          <div class="row">
            <div class="left">承运人</div>
            <div class="right">{{data.ExpressCompany}}</div>
          </div>
        </div>
      </div>
    </div>
    <div v-for="(item, index) in data.Products" :key="'p'+index">
      <div class="section-group" v-if="item.ProductType===2 && item.Status===5">
        <div class="header">
          <div class="left">{{item.StockTitle}}</div>
          <div class="right">
            <!-- <van-button
              type="warning"
              round
              size="mini"
              class="btn-mini"
              @click="getVirtualCode(item)"
            >查看电子码</van-button> -->
          </div>
        </div>
        <div class="section-bg section-padding goods-list" v-if="item.Codes">
          <!-- <div v-for="(code,i) in item.Codes" :key="i">{{ code }}</div> -->
          <div v-for="(code,i) in item.Codes" :key="i" class="coupon3">
            <div v-for="(field,i) in code.Fields" :key="'f' + i" class="coupons-item">
              <van-row type="flex" justify="space-between">
                <van-col span="20" class="item-info">
                  <span v-if="checkUrl(field.Value)">{{ field.Key }} : <a :href="field.Value" target="_blank"> {{field.Value}}</a></span>
                  <span v-else>{{ field.Key }} : {{field.Value}}</span>
                </van-col>
                <van-col span="4" class="item-btn">
                  <!-- <van-button round @click="doCopy(field.Value)" style="float:right;" icon="icon-copy">复制</van-button> -->
                  <!-- <van-icon
                    class-prefix="iconfont"
                    name="s icon-fuzhi"
                    @click="doCopy(field.Key,field.Value)"
                  ></van-icon> -->
                  
                    <van-tag round color="#fff" text-color="#fff" plain @click="doCopy(field.Key,field.Value)">复制</van-tag>
                </van-col>
              </van-row>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-for="(item, index) in data.Products" :key="index">
      <div class="section-group" v-if="item.ProductType===3 && item.Status===5">
        <div class="header">
          <div class="left">{{item.StockTitle}}</div>
          <div class="right">
            <van-button
              type="warning"
              round
              size="mini"
              class="btn-mini"
              @click="getOtherVirtualCode(item)"
            >查看</van-button>
          </div>
        </div>
        <div class="section-bg section-padding goods-list" v-if="item.OtherCodes">
          <div style="position:relative;">
            <!-- <div v-for="(code,i) in item.OtherCodes" :key="i" class="coupons">
              <div class="coupons-item">{{ code }}</div>
            </div>-->
            <div v-for="(code,i) in item.OtherItems" :key="i" class="coupon3">
              <div v-for="(field,i) in code.Fields" :key="'f' + i" class="coupons-item">
                <van-row type="flex" justify="space-between">
                  <van-col span="20" class="item-info">
                    <span v-if="checkUrl(field.Value)">{{ field.Key }} : <a :href="field.Value" target="_blank"> {{field.Value}}</a></span>
                    <span v-else>{{ field.Key }} : {{field.Value}}</span>
                  </van-col>
                  <van-col span="4" class="item-btn">
                    <!-- <van-button round @click="doCopy(field.Value)" style="float:right;" icon="icon-copy">复制</van-button> -->
                    <!-- <van-icon
                      class-prefix="iconfont"
                      name="s icon-fuzhi"
                      @click="doCopy(field.Key, field.Value)"
                    ></van-icon> -->
                    <van-tag round color="#fff" text-color="#fff" plain @click="doCopy(field.Key,field.Value)">复制</van-tag>
                  </van-col>
                </van-row>
              </div>
            </div>
          </div>
          <!-- <div class="coupon">
            <div class="coupon-left">
              <div class="con">sdf</div>
            </div>
            <div class="coupon-con"></div>
          </div>-->
          <!-- <div class="coupon2">sss</div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SkuItem from "@/components/SkuItem.vue";
export default {
  props: ["orderNo"],
  components: { SkuItem },
  data() {
    return {
      key: "value",
      data: {}
    };
  },
  activated() {
    this.loadDetail();
  },
  computed: {
    hasAddress() {
      if (this.data.Products) {
        for (var i = 0; i < this.data.Products.length; i++) {
          if (this.data.Products[i].ProductType === 1) {
            return true;
          }
        }
      }
      return false;
    }
  },
  methods: {
    checkUrl(str){      
      if (str && str.indexOf("http")===0)
        return true;
      else
        return false;
    },
    loadDetail() {
      var that=this;
      this.$ajax.get("/api/user/order/" + this.orderNo).then(response => {
        if (response.data.code === 1) {
          this.data = response.data.data;
          //查询码
          this.data.Products.forEach(function(item){
            //console.log(item);
            if(item.ProductType===2 && item.Status===5){
              that.getVirtualCode(item);
            }
            
            if(item.ProductType===3 && item.Status===5){
              that.getOtherVirtualCode(item);
            }
          })
        }
      });
    },
    getStatusText(status) {
      switch (status) {
        case 1:
          return "待付款";
        case 2:
          return "已支付";
        case 3:
          return "已发货";
        case 4:
          return "已取消";
        case 5:
          return "已完成";
        case 6:
          return "已退款";
        default:
          return "";
      }
    },
    getRechargeStatusText(status) {
      switch (status) {
        case 1:
          return "充值中";
        case 2:
          return "充值成功";
        case 3:
          return "充值失败";
        default:
          return "";
      }
    },
    getVirtualCode(orderProduct) {
      var obj = this;
      this.$ajax
        .get("/api/user/order/virtual/" + orderProduct.Id)
        .then(response => {
          if (response.data.code === 1) {
            //orderProduct.Codes = response.data.data.VirtualProducts;
            obj.$set(orderProduct, "Codes", response.data.data.VirtualItems);
          }
        });
    },
    getOtherVirtualCode(orderProduct) {
      var obj = this;
      this.$ajax
        .get("/api/user/order/othervirtual/" + orderProduct.Id)
        .then(response => {
          if (response.data.code === 1) {
            //orderProduct.Codes = response.data.data.VirtualProducts;
            obj.$set(
              orderProduct,
              "OtherCodes",
              response.data.data.VirtualProducts
            );
            obj.$set(
              orderProduct,
              "OtherItems",
              response.data.data.VirtualItems
            );
          }
        });
    },
    doCopy(key, text) {
      var obj = this;
      this.$copyText(text).then(
        function() {
          obj.$toast(key + "复制成功");
          //console.log(e);
        },
        function(e) {
          obj.$toast("复制失败");
          console.log(e);
        }
      );
    }
  }
};
</script>

<style lang="less" scoped>
@import "../assets/base-var.less";
.address {
  display: flex;
  padding: 10px 15px;
  background: #fff;
}
.address .icon {
  padding: 2px 10px 0 0;
}
.address .info {
  flex: 1;
}
.address .info .name {
  font-size: 14px;
  margin-bottom: 5px;
}
.address .info .detail {
  font-size: 12px;
  color: @gray-color;
}
.total-price {
  color: #f44;
  font-size: 16px;
  font-weight: bold;
}
.coupons {
  position: relative;
  min-height: 45px;
  background-size: calc(100% - 15px) 18px;
  background-image: radial-gradient(
      circle at 1px 10px,
      transparent 6px,
      #ff5050 6px,
      #ff5050 0px
    ),
    radial-gradient(
      circle at calc(100% - 1px) 10px,
      transparent 6px,
      #ff5050 6px,
      #ff5050 0px
    );
  // background-image: radial-gradient(
  //   transparent 0,
  //   transparent 5px,
  //   #ff9e6d 5px
  // );
  background-repeat: repeat-y;
  background-position: 0 0, 50% 0;
  //background-position: 8px 3px;
  padding: 8px 20px;
  margin-bottom: 5px;
  //width: calc(100%-30px);
}
.coupons-item {
  color: #fff;
  font-size: 14px;
  padding: 2px 0;
  height: 22px;
  line-height: 22px;
}
.coupons-item .item-btn {
  text-align: right;
}

.coupons-item .item-info {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.coupons-item .item-btn .van-tag{
  background-color:transparent;
}
.coupons-item a{
  color:#fff;
  text-decoration:underline;
}
// 优惠券
.coupon {
  display: flex;
  border-radius: 10px;
  overflow: hidden;
}
.coupon-left {
  width: 150px;
  height: 150px;
  position: relative;
  color: #fff;
}
.coupon-left::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 50%;
  background: radial-gradient(
    circle at right top,
    transparent 10px,
    #252525 10px,
    #252525 10px
  );
}
.coupon-left::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 50%;
  background: radial-gradient(
    circle at right bottom,
    transparent 10px,
    #252525 10px,
    #252525 10px
  );
}
.coupon-con {
  height: 150px;
  height: 100%;
}
.coupon-left .con {
  color: darkorange;
  z-index: 9999;
  padding: 20px;
}
.coupon2 {
  position: relative;
  //width: 160px;
  min-height: 80px;
  background-image: radial-gradient(
    circle at 10px 8px,
    transparent 0%,
    transparent 8px,
    #ff5050 5px,
    #ff5050 100%
  );
  border-radius: 10px;
  background-position: 60px -8px;
  background-size: 100% 100%;
  padding: 8px 20px 6px 90px;
  margin-bottom: 5px;
}
.coupon2::before {
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  left: 69px;
  border: 1px dashed #fff;
}

.coupon3{
  position: relative;
  //width: 160px;
  min-height: 80px;
  background-color: #ff5050;
  border-radius: 10px;
  padding:8px;
  margin-bottom: 5px;
}

</style>